import React, { useEffect, useState } from 'react'
import { Combobox } from 'react-widgets'
import DatePicker from '../Layout/DatePicker'

const FilterBar = ({
  onHandleFilter
}) => {
  const [filterData, setFilterData] = useState({
    StartDate: new Date(new Date().getFullYear(), 0, 1),
    EndDate: new Date(),
    LiveListBy: 'Branch',
  })

  // LIST BY
  const listBy = [
    {value: 'Branch', name: 'Branch'},
    {value: 'Group', name: 'Group'}
  ]

  const handleSelectStartDate = (date) => {
    setFilterData((prev) => ({
      ...prev,
      StartDate: date,
    }));
  }

  const handleSelectEndDate = (date) => {
    setFilterData((prev) => ({
      ...prev,
      EndDate: date,
    }));
  }

  const handleSelectListedBy = (selected) => {
    setFilterData((prev) => ({
      ...prev,
      LiveListBy: selected.value,
    }));
  };

  const handleFilter = () => {
    onHandleFilter(filterData)
  }

  useEffect(() => {
    handleFilter()
  }, [])

  return (
    <div className='w-full py-2 px-4 bg-white flex xl:flex-row flex-col justify-start xl:items-center relative z-30 shadow gap-1'>
      <div className='flex md:flex-nowrap flex-wrap items-center gap-1'>
        <div className='md:w-40 md:flex-none flex-1 relative'>
          <label className='absolute top-0 -translate-y-1/3 left-2 z-10 text-[10px] bg-white leading-none px-1 text-gray-two'>
            Start Date
          </label>

          <DatePicker
            selectedDate={ filterData.StartDate }
            onSelect={ handleSelectStartDate }
          />
        </div>

        <div className='md:w-40 md:flex-none flex-1 relative'>
          <label className='absolute top-0 -translate-y-1/3 left-2 z-10 text-[10px] bg-white leading-none px-1 text-gray-two'>
            End Date
          </label>

          <DatePicker
            selectedDate={ filterData.EndDate }
            onSelect={ handleSelectEndDate }
          />
        </div>

        <div className='md:w-40 md:flex-none flex-1 relative'>
          <label className='absolute top-0 -translate-y-1/3 left-2 z-10 text-[10px] bg-white leading-none px-1 text-gray-two'>
            List By
          </label>

          <Combobox
            className="list-box"
            data={ listBy }
            defaultValue={ filterData.LiveListBy }
            dataKey='value'
            textField='name'
            onSelect={ handleSelectListedBy }
            filter='contains'
          />
        </div>
      </div>

      <div className='flex md:flex-nowrap flex-wrap items-center md:gap-2 gap-1 ml-2'>
        <button
          onClick={ handleFilter }
          type="button"
          className='py-1 h-[34px] px-3 md:flex-none flex-1 whitespace-nowrap rounded-md border border-primary text-sm text-primary cursor-pointer focus-visible:outline-none bg-white hover:bg-primary hover:text-white transition-all'
        >
          Search
        </button>
      </div>
    </div>
  )
}

export default FilterBar